import { HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import { type BulkUpdatePlotRequestDetailsRequest } from "@/features/map/types";
import { useApiClient } from "@/hooks/useApiClient";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

/**
 * プロット詳細を一括更新するカスタムフック
 */
export const useBulkUpdatePlotRequestDetails = (): SWRMutationResponse<
  void,
  Error,
  string,
  BulkUpdatePlotRequestDetailsRequest
> => {
  const { apiClient } = useApiClient();
  const url = "/map/plot-request-details";

  const fetcher = async (
    url: string,
    { arg }: { arg: BulkUpdatePlotRequestDetailsRequest }
  ): Promise<void> => {
    try {
      const response = await apiClient.patch(url, arg);

      if (response.status !== HttpStatusCode.Ok) {
        throw new Error("一括更新に失敗しました");
      }
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    }
  };

  return useSWRMutation(url, fetcher, { revalidate: false });
};
